var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgHidden = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37855 3.14999C4.28788 3.05332 4.16127 2.99847 4.02877 2.99847C3.89626 2.99847 3.76966 3.05332 3.67898 3.14999L3.1493 3.67999C3.05268 3.77073 2.99788 3.89741 2.99788 4.02999C2.99788 4.16258 3.05268 4.28926 3.1493 4.37999L5.74772 6.99999C4.05624 8.1321 2.76555 9.77007 2.05997 11.68C2.02264 11.7827 2.00239 11.8908 2 12C1.99947 12.1063 2.01985 12.2116 2.05997 12.31C3.68478 16.3691 7.62405 19.022 11.9939 19C13.6108 18.9845 15.2044 18.6124 16.6611 17.91L19.6093 20.85C19.6999 20.9467 19.8266 21.0015 19.9591 21.0015C20.0916 21.0015 20.2182 20.9467 20.3088 20.85L20.8385 20.32C20.9351 20.2293 20.99 20.1026 20.99 19.97C20.99 19.8374 20.9351 19.7107 20.8385 19.62L4.37855 3.14999ZM11.9939 15C10.3381 15 8.99574 13.6568 8.99574 12C8.99826 11.5095 9.12552 11.0277 9.36551 10.6L13.3631 14.6C12.9473 14.8458 12.4765 14.9833 11.9939 15ZM9.11567 5.40999C14.3846 3.88142 19.9529 6.60236 21.9878 11.7C22.004 11.7993 22.004 11.9007 21.9878 12C21.9911 12.113 21.9706 12.2254 21.9279 12.33C21.4348 13.6826 20.6382 14.9039 19.5993 15.9L9.11567 5.40999Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHidden, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hidden.ab92c780.svg";
export { ForwardRef as ReactComponent };